var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66444 0.65572C6.69656 0.398762 6.55543 0.151389 6.31789 0.0482734C6.08035 -0.0548417 5.80326 0.0109885 5.63748 0.209925L0.42863 6.46055C0.338613 6.56853 0.247437 6.6779 0.181053 6.77401C0.118271 6.86491 0.00364149 7.04363 9.969e-05 7.27851C-0.00395503 7.54741 0.115868 7.80323 0.325037 7.97226C0.507746 8.11991 0.718426 8.14626 0.828447 8.15622C0.944777 8.16675 1.08716 8.16673 1.22774 8.1667L4.84149 8.1667L4.34012 12.1777C4.308 12.4346 4.44912 12.682 4.68667 12.7851C4.92421 12.8882 5.20129 12.8224 5.36708 12.6235L10.5759 6.37286C10.6659 6.26487 10.7571 6.1555 10.8235 6.05939C10.8863 5.96849 11.0009 5.78977 11.0045 5.55489C11.0085 5.28599 10.8887 5.03017 10.6795 4.86114C10.4968 4.71349 10.2861 4.68714 10.1761 4.67718C10.0598 4.66664 9.91739 4.66667 9.77681 4.6667L6.16307 4.6667L6.66444 0.65572Z",
    fill: "#3538CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/Lighting.9d909483b8df64b39bc2e1513163cb40.svg";
export { ForwardRef as ReactComponent };